var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.129703 14.0183C0.215913 14.1045 0.329092 14.1474 0.442271 14.1474C0.55545 14.1474 0.668629 14.1041 0.755281 14.0179L7.07385 7.6918L13.3924 14.0179C13.4786 14.1045 13.5918 14.1474 13.7054 14.1474C13.8186 14.1474 13.9318 14.1041 14.018 14.0183C14.1909 13.8459 14.1909 13.5661 14.0184 13.3932L7.70606 7.07374L14.018 0.754729C14.1904 0.581866 14.1904 0.302013 14.0176 0.129592C13.8442 -0.0432711 13.5648 -0.0432709 13.3924 0.130034L7.07341 6.45612L0.75484 0.130034C0.581976 -0.0428288 0.302124 -0.042829 0.129703 0.129592C-0.0431606 0.302013 -0.0431603 0.581866 0.129261 0.754729L6.44075 7.07374L0.129261 13.3932C-0.0431603 13.5656 -0.0431606 13.8459 0.129703 14.0183Z",
    fill: "#4B5258"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.065c4232a1a2574fa040302a4c98609c.svg";
export { ForwardRef as ReactComponent };